// src/app/core/interceptors/loader.tokens.ts
import { HttpContextToken } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

export interface LoaderOptions {
  label?: string;  // text shown in the overlay
}

export const LOADER_OPTS = new HttpContextToken<LoaderOptions>(() => ({}));

/** Optional: mark a request to skip the global loader entirely */
export const SKIP_GLOBAL_LOADER = new HttpContextToken<boolean>(() => false);

export interface LoaderDefaults { showDelayMs: number; minVisibleMs: number; }
export const LOADER_DEFAULTS = new InjectionToken<LoaderDefaults>('LOADER_DEFAULTS');
